import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import VueCookies from 'vue3-cookies';
import "./assets/css/bootstrap.min.css";
// import 'bootstrap/dist/css/bootstrap.min.css'; // already done
// import "./assets/css/chat.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/fontawesome/css/all.css";
// import "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import globalProperties from './globalServices';
// import Clarity from '@microsoft/clarity';
// Clarity.init(process.env.VUE_APP_CLARITY_PROJECT_ID);
// import * as Sentry from "@sentry/vue";
import { setStore, setTranslatedDataFn } from '@template/utils';
import { translatedData } from './shared/services/languageService';

async function initApp() {
    await setStore(store);
    setTranslatedDataFn(translatedData);

    const app = createApp(App);
    // Sentry.init({
    //     app,
    //     dsn: process.env.VUE_APP_SENTRY_PROJECT_KEY,
    //     integrations: [
    //         Sentry.browserTracingIntegration({ router }),
    //         Sentry.replayIntegration(),
    //     ],
    //     tracesSampleRate: 1.0,
    //     replaysSessionSampleRate: 0.1,
    //     replaysOnErrorSampleRate: 1.0,
    // });
    app.use(globalProperties);
    app.use(router);
    app.use(store);
    app.use(VueCookies);
    await router.isReady(); 
    app.mount("#app");
};

initApp();

window.addEventListener('popstate', (event) => {
    if(document.querySelector('.modal.show')) {
        window.location.reload();
    }
});


// this code is for scroll to top on reload 
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

window.onload = function() {
  window.scrollTo(0, 0);
};